let Url, ApiUrl, BaseUrl, appsUrl, resourceUrl;
let domainUrl = 'okzhuan.com';
if (process.env.NODE_ENV === 'development' || (window.location.host).indexOf('lkdev-') > -1) {
    ApiUrl = 'https://lkdev-api.' + domainUrl + '/';
    BaseUrl = 'https://lkdev-app.' + domainUrl + '/';
    appsUrl = 'https://lkdev-apps.' + domainUrl + '/';
    resourceUrl = '//lkdev-resource.' + domainUrl + '/';
} else {
    ApiUrl = 'https://api.' + domainUrl + '/';
    BaseUrl = 'https://app.' + domainUrl + '/';
    appsUrl = 'https://apps.' + domainUrl + '/';
    resourceUrl = '//resource.' + domainUrl + '/';
}
Url = 'www.' + domainUrl;
export {
    Url,
    ApiUrl,
    BaseUrl,
    appsUrl,
    resourceUrl
}
